<div class="otf-backdrop" *ngIf="visible" (click)="close()"></div>

<div class="otf-drawer" [class.open]="visible" [class.compact]="compact">
  <!-- Header -->
  <div class="otf-header">
    <div class="otf-header-left">
      <span class="otf-icon-wrap">
        <mat-icon>bolt</mat-icon>
      </span>
      <div>
        <h3 class="otf-title">On-the-Fly Computation</h3>
        <p class="otf-subtitle">Build expressions using columns and apply</p>
      </div>
    </div>
    <button type="button" class="otf-close-btn" (click)="close()" matTooltip="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="otf-body">

    <!-- Entity Name -->
    <div class="otf-section">
      <label class="otf-label">Entity Name</label>
      <div class="otf-entity-input">
        <mat-icon class="otf-entity-icon">dataset</mat-icon>
        <input type="text" class="otf-input" [value]="entityName()" readonly placeholder="No dataset loaded" />
      </div>
    </div>

    <!-- Available Columns + sliderValue token -->
    <div class="otf-section" *ngIf="allColumns().length">
      <label class="otf-label">Available Columns</label>
      <div class="otf-chips">
        <button type="button" class="otf-chip otf-chip-slider-token"
          (click)="appendSliderValue()"
          matTooltip="Insert sliderValue — resolves to the value set on the slider below">
          <mat-icon class="otf-chip-icon">tune</mat-icon>
          sliderValue = {{ sliderValue() }}
        </button>
        <button *ngFor="let col of allColumns()" type="button" class="otf-chip"
          [class.numeric]="col.type === 'number'"
          (click)="appendColumn(col)" [matTooltip]="col.type">
          <mat-icon class="otf-chip-icon">{{ col.type === 'number' ? 'tag' : 'text_fields' }}</mat-icon>
          {{ col.name }}
        </button>
      </div>

      <!-- sliderValue control -->
      <!-- <div class="otf-slider-token-control">
        <label class="otf-slider-token-label">
          <mat-icon>tune</mat-icon>
          sliderValue
          <span class="otf-slider-token-value">{{ sliderValue() }}</span>
        </label>
        <div class="otf-slider-input-group">
          <input type="range" class="otf-slider"
            [min]="sliderMin" [max]="sliderMax" [value]="sliderValue()" step="1"
            (input)="updateSliderFromRange($event)" />
          <input type="number" class="otf-range-input"
            [min]="sliderMin" [max]="sliderMax" [value]="sliderValue()"
            (change)="updateSliderFromNumber($event)" />
        </div>
      </div> -->
    </div>

    <!-- Expression Builder -->
    <div class="otf-section">
      <label class="otf-label">Build Expression</label>
      <div class="otf-expr-row">
        <div class="otf-field-wrap">
          <label class="otf-field-label">Expression</label>
          <input type="text" class="otf-input otf-expr-input" [(ngModel)]="currentExpression"
            placeholder="e.g. profit * sliderValue  or  profit + discount" />
        </div>
        <div class="otf-field-wrap otf-alias-wrap">
          <label class="otf-field-label">Alias <span class="otf-hint">as name</span></label>
          <input type="text" class="otf-input" [(ngModel)]="currentAlias" placeholder="e.g. revenue" />
        </div>
        <button type="button" class="otf-add-btn" (click)="addComputation()" matTooltip="Add computation">
          <mat-icon>add</mat-icon>
        </button>
      </div>
      <p class="otf-field-error" *ngIf="expressionError">{{ expressionError }}</p>
      <p class="otf-expr-hint">Format: <code>expression as alias</code> — click columns above to insert them</p>
    </div>

    <!-- Active Computations -->
    <div class="otf-section" *ngIf="computations().length">
      <label class="otf-label">
        Active Computations
        <span class="otf-badge">{{ computations().length }}</span>
      </label>
      <div class="otf-computation-list">
        <div class="otf-computation-item" *ngFor="let comp of computations(); trackBy: trackById">
          <div class="otf-computation-body">
            <code class="otf-computation-expr">{{ comp.expression }}</code>
            <span class="otf-computation-as">as</span>
            <span class="otf-computation-alias">{{ comp.alias }}</span>
          </div>
          <button type="button" class="otf-remove-btn" (click)="removeComputation(comp.id)" matTooltip="Remove">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Live Computed Results Panel -->
    <div class="otf-section otf-result-panel-section" *ngIf="hasLiveResults()">
      <label class="otf-label">
        <mat-icon style="font-size:14px;width:14px;height:14px;color:inherit">calculate</mat-icon>
        Live Preview
        <span class="otf-hint">— updates as you move the slider</span>
      </label>
      <div class="otf-result-panel">
        <div
          *ngFor="let result of liveComputedResults()"
          class="otf-result-row"
          [class.otf-result-row--error]="result.value === null">
          <span class="otf-result-label">{{ result.alias }}</span>
          <span class="otf-result-value">
            <ng-container *ngIf="result.value !== null; else errorVal">
              {{ formatResultValue(result.value) }}
            </ng-container>
            <ng-template #errorVal>
              <mat-icon class="otf-result-error-icon" matTooltip="Check your expression — could not evaluate">warning</mat-icon>
              check formula
            </ng-template>
          </span>
        </div>
      </div>
    </div>

    <!-- Active Dashboard Filters (read-only, auto-applied on Apply) -->
    <div class="otf-section otf-dashboard-filters-section">
      <label class="otf-label">
        <mat-icon style="font-size:14px;width:14px;height:14px;">filter_list</mat-icon>
        Dashboard Filters
        <span class="otf-hint">— sent automatically</span>
      </label>
      <ng-container *ngIf="activeDashboardFilters().length; else noFilters">
        <div class="otf-dashboard-filter-chips">
          <span class="otf-dashboard-filter-chip" *ngFor="let f of activeDashboardFilters()">
            <strong>{{ f.key }}</strong>: {{ f.value | json }}
          </span>
        </div>
      </ng-container>
      <ng-template #noFilters>
        <p class="otf-no-filters-hint">No dashboard filters active. Select filters above and they'll be sent automatically.</p>
      </ng-template>
    </div>

  </div>

  <!-- Footer -->
  <div class="otf-footer">
    <p class="otf-error-msg" *ngIf="errorMessage()">
      <mat-icon>error_outline</mat-icon>
      {{ errorMessage() }}
    </p>
    <p class="otf-success-msg" *ngIf="successMessage()">
      <mat-icon>check_circle_outline</mat-icon>
      {{ successMessage() }}
    </p>
    <div class="otf-footer-actions">
      <button type="button" class="otf-btn-secondary" (click)="clearAll()">
        <mat-icon>clear_all</mat-icon>
        Clear All
      </button>
      <button type="button" class="otf-btn-primary" (click)="apply()" [disabled]="loading()">
        <mat-icon>{{ loading() ? 'hourglass_empty' : 'play_arrow' }}</mat-icon>
        {{ loading() ? 'Fetching...' : 'Apply' }}
      </button>
    </div>
  </div>
</div>
